<!-- Existing Photos Section -->
<div class="photo-manager">
<div class="existing-photos-section">
  <ion-text color="medium">
    <h2>Existing Photos</h2>
  </ion-text>
  <!-- One mixed grid here, not a grid per kind: deletion emits an index into this
       exact list, so it must stay whole. The per-thumbnail kind label carries what
       the details panel's headings carry. -->
  <app-photo-grid-viewer
    [photos]="logRowPhotos"
    [viewingLogRow]="true"
    [showKindLabels]="true"
    (deletePhoto)="deleteExistingPhoto($event)"
    (deleteAllPhotos)="deleteAllExistingPhotos()">
  </app-photo-grid-viewer>
</div>

<!-- New Photos Section — one bucket per section, matching the mobile flow's
     photos step: an add tile that opens the camera (mobile) or a file dialog
     (desktop), and the whole grid also takes dropped files. The section a photo
     lands in is carried by its file name, so nothing is uploaded loose. -->
<div class="new-photos-section">
  <ion-text color="medium">
    <h2>Add New Photos</h2>
  </ion-text>
  <p class="sections-hint">
    Drop photos onto a section, or use its
    {{ isMobile ? 'camera' : 'upload' }} tile. Nothing uploads until you press
    Upload New Photos.
  </p>

  <!-- Full-width sections ahead of the categories (the packing slip: many pages,
       so it gets the whole width and a wider thumbnail grid) -->
  <div class="photo-section wide-section" *ngFor="let section of leadingSections"
       [class.section-filled]="bucketFor(section.key).photos.length">
    <ng-container *ngTemplateOutlet="sectionCard; context: { $implicit: section }"></ng-container>
  </div>

  <!-- Shipment categories, three across on desktop and stacked on narrow screens -->
  <div class="section-row">
    <div class="photo-section" *ngFor="let section of rowSections"
         [class.section-filled]="bucketFor(section.key).photos.length">
      <ng-container *ngTemplateOutlet="sectionCard; context: { $implicit: section }"></ng-container>
    </div>
  </div>

  <!-- Full-width sections after the categories (extras) -->
  <div class="photo-section wide-section" *ngFor="let section of trailingSections"
       [class.section-filled]="bucketFor(section.key).photos.length">
    <ng-container *ngTemplateOutlet="sectionCard; context: { $implicit: section }"></ng-container>
  </div>

  <!-- One card's insides, shared by both layouts above -->
  <ng-template #sectionCard let-section>
    <div class="section-head">
      <span class="section-title">{{ section.title }}</span>
      <span class="section-existing" *ngIf="existingCountFor(section.key)">
        {{ existingCountFor(section.key) }} on file
      </span>
    </div>
    <div class="section-hint" *ngIf="!bucketFor(section.key).photos.length">
      {{ section.hint }}
    </div>

    <div class="section-grid"
         appFileDropTarget
         [dropDisabled]="bucketFor(section.key).adding"
         (filesDropped)="onSectionFilesDropped(section.key, $event)">
      <button class="photo-add-tile"
              (click)="addToSection(section.key)"
              [disabled]="bucketFor(section.key).adding"
              [title]="isMobile ? 'Take photo' : 'Add files'">
        <ion-icon [name]="isMobile ? 'camera-outline' : 'cloud-upload-outline'"></ion-icon>
      </button>

      <!-- role/tabindex rather than a <button>: each thumbnail holds its own
           remove button, and a button may not nest inside a button. -->
      <div *ngFor="let photo of bucketFor(section.key).photos; let i = index"
           class="section-thumb"
           role="button" tabindex="0"
           [attr.aria-label]="'View ' + section.title + ' photo ' + (i + 1)"
           (click)="openPendingViewer(section.key, i)"
           (keydown.enter)="openPendingViewer(section.key, i)"
           (keydown.space)="openPendingViewer(section.key, i)">
        <img [src]="photo.url" [alt]="section.title" class="section-img" />
        <button class="thumb-remove-btn"
                [attr.aria-label]="'Remove ' + section.title + ' photo ' + (i + 1)"
                (click)="removePending(section.key, i); $event.stopPropagation()">
          <ion-icon name="close-outline"></ion-icon>
        </button>
      </div>

      <!-- Processing placeholder while a resize / PDF split runs -->
      <div *ngIf="bucketFor(section.key).adding" class="section-thumb thumb-working">
        <ion-spinner name="crescent"></ion-spinner>
      </div>
    </div>
  </ng-template>

</div>

<!-- Action Buttons -->
<div class="action-buttons">
  <ion-button (click)="closeModal.emit()" fill="outline">
    Cancel
  </ion-button>
  <ion-button
    color="danger"
    fill="outline"
    *ngIf="pendingCount > 0"
    (click)="deleteAllPending()">
    Discard added
  </ion-button>
  <ion-button
    (click)="uploadNewPhotos()"
    [disabled]="pendingCount === 0 || dataLoading.isLoading">
    <ion-spinner *ngIf="dataLoading.isLoading" name="crescent" class="upload-spinner"></ion-spinner>
    Upload New Photos
    <span *ngIf="pendingCount > 0">&nbsp;({{ pendingCount }})</span>
  </ion-button>
</div>

<!-- Full-screen viewer for the staged photos -->
<app-photo-viewer-modal
  [isOpen]="isViewerOpen"
  [photoList]="viewerPhotos"
  [initialIndex]="viewerIndex"
  (closeModal)="closePendingViewer()">
</app-photo-viewer-modal>

</div>
